import React from 'react'

const Projects = () => {
  return (
    <div className='relative z-0'>
      <div className='hidden md:flex'>
    <div className='absolute  top-[1900px]  w-full  text-center  font-poppins  justify-center  '>
      <h1 className='text-7xl text-bold py-5' >Projects</h1>
      <div className='flex flex-row overflow-y-auto space-x-10 py-20'>
      <button className='shadow-2xl shadow-slate-400  bg-slate-200 rounded-xl px-5 py-10 hover:animate-pulse text-black font-poppins ' href="">
      <h1 className='text-black font-poppins text-3xl'>WELLNESS- INSTINCTS</h1>
              <div className=' text-zinc-500 font-serif text-xl w-[500px]'> 
              <h1 className='mt-10 py-10'>mental health care website with chatbot and minigames PARTICIPATED IN NATIONAL LEVEL HACKATHON @MUMBAI  </h1>
              <h1 className='font-poppins py-10'>Healthcare Web App - 36-Hour Hackathon</h1>
              <h1 className=' py-10'>Developed a fully-fledged healthcare website during a 36-hour continuous hackathon.
Utilized HTML, CSS, and JavaScript for the front-end development, creating an intuitive and user-friendly interface.</h1>
              <h1 className=' py-10'>Implemented MongoDB as the database management system to efficiently store and retrieve healthcare-related data.
Leveraged Flask, a Python-based web framework, for the back-end development, enabling seamless integration and handling of user requests.
 </h1>
              </div>
              </button>
              <button className='shadow-2xl shadow-slate-400 bg-slate-200 rounded-xl px-5 py-10 hover:animate-pulse text-black font-poppins  ' href="">
      <h1 className='text-black font-poppins pb-14 text-3xl'>HOME-SERVICES</h1>
              <div className=' text-zinc-500 font-serif text-xl w-[500px]'> 
              <h1 className='font-poppins py-20'>WEB APP  BUILT USING PHP,MYSQL,CSS,XAMPP (mini project)
</h1>
              <h1 className=' py-10'>Developed a web application for home services using PHP, MySQL, and XAMPP.
Collaborated with a team to design and implement features including service listing, booking, and payment integration.
Utilized PHP for server-side scripting and MySQL for database management.</h1>
              <h1 className=' py-10'>Overcame challenges in implementing complex booking functionality and integrating a secure payment gateway.
Demonstrated proficiency in PHP, MySQL, and other related technologies.
Accessed local development environment using XAMPP for seamless testing and debugging
 </h1>
              </div>
              </button>
              <button className='shadow-2xl shadow-slate-400 bg-slate-200 rounded-xl px-5 py-10 hover:animate-pulse text-black font-poppins  ' href="">
      <h1 className='text-black font-poppins pb-10 text-3xl'>ARDUINO UNO PROJECT</h1>
              <div className=' text-zinc-500 font-serif text-xl w-[500px]'> 
              <h1 className='font-poppins py-10'>Smart Power Cut Notifier using Arduino Uno</h1>
              <h1 className=' py-10'>Developed a Smart Power Cut Notifier using Arduino Uno, addressing the need for efficient power outage detection and notification.
Designed a system where the Arduino board detects power cuts in specific houses while neighboring houses maintain power supply.
Implemented a messaging feature to instantly alert the operator with the specific address where the power outage occurs, enabling quick error identification and resolution.
</h1>
              <h1 className=' py-10'>Developed a web interface that displays real-time information regarding the availability of power supply in each house, providing a convenient solution for both operators and users.
Demonstrated problem-solving skills and technical expertise in hardware programming, utilizing Arduino Uno to accurately detect power cuts and transmit notifications.</h1>
              </div>
              </button>

              <button className='shadow-2xl shadow-slate-400 bg-slate-200 rounded-xl px-5 py-10 hover:animate-pulse text-black font-poppins  ' href="">
      <h1 className='text-black font-poppins pb-10 text-3xl'>HER-INSTINCTS</h1>
              <div className=' text-zinc-500 font-serif text-xl w-[500px]'> 
              <h1 className='font-poppins py-20'> Comprehensive website catering to women's care using HTML, Tailwind CSS, and Python.
</h1>
              <h1 className=' py-10'>Implemented HTML to structure the website's content, ensuring a clean and organized layout.
Utilized Tailwind CSS to create a visually appealing and responsive design, enhancing user experience across different devices.</h1>
              <h1 className=' py-10'>Leveraged Python to add dynamic functionality, such as personalized recommendations and content based on individual preferences.
Incorporated various features, including health tips, beauty routines, lifestyle advice, and empowerment resources, to address the unique needs of women.

 </h1>
              </div>
              </button>

              </div>  
    </div>
    </div>

    <div className='flex md:hidden '>
    <div className='absolute  top-[1800px]  w-full  text-left  font-poppins  justify-center py-20 '>
      <h1 className='text-slate-950 font-poppins text-3xl py-5'>Projects</h1>

      <div className='flex flex-row overflow-y-auto space-x-10'>

      <button className='shadow-2xl shadow-slate-400 bg-slate-200 rounded-xl px-5 py-10 hover:animate-pulse text-black text-left font-poppins  ' href="">
      <h1 className='text-black font-poppins  text-2xl'>WELLNESS- INSTINCTS</h1>
              <div className=' text-zinc-500 font-serif text-xl w-[400px]'> 
              <h1 className='mt-10 py-10'>mental health care website with chatbot and minigames PARTICIPATED IN NATIONAL LEVEL HACKATHON @MUMBAI  </h1>
              <h1 className='font-poppins py-10'>Healthcare Web App - 36-Hour Hackathon</h1>
              <h1 className=' py-10'>Developed a fully-fledged healthcare website during a 36-hour continuous hackathon.
Utilized HTML, CSS, and JavaScript for the front-end development, creating an intuitive and user-friendly interface.</h1>
              <h1 className=' py-10'>Implemented MongoDB as the database management system to efficiently store and retrieve healthcare-related data.
Leveraged Flask, a Python-based web framework, for the back-end development, enabling seamless integration and handling of user requests.
 </h1>
              </div>
              </button>
              <button className='shadow-2xl shadow-slate-400 bg-slate-200 rounded-xl px-5 py-10 pb-20 hover:animate-pulse text-black text-left font-poppins  ' href="">
      <h1 className='text-black font-poppins pb-20 text-2xl'>HOME-SERVICES</h1>
              <div className=' text-zinc-500 font-serif text-xl w-[400px]'> 
              <h1 className='font-poppins py-10'>WEB APP  BUILT USING PHP,MYSQL,CSS,XAMPP (mini project)
</h1>
              <h1 className=' py-10'>Developed a web application for home services using PHP, MySQL, and XAMPP.
Collaborated with a team to design and implement features including service listing, booking, and payment integration.
Utilized PHP for server-side scripting and MySQL for database management.</h1>
              <h1 className=' py-10'>Overcame challenges in implementing complex booking functionality and integrating a secure payment gateway.
Demonstrated proficiency in PHP, MySQL, and other related technologies.
Accessed local development environment using XAMPP for seamless testing and debugging
 </h1>
              </div>
              </button>
              <button className='shadow-2xl shadow-slate-400 bg-slate-200 rounded-xl px-5 py-10 pb-20 hover:animate-pulse text-black text-left font-poppins  ' href="">
      <h1 className='text-black font-poppins pt-10 text-2xl'>ARDUINO UNO PROJECT</h1>
              <div className=' text-zinc-500 font-serif text-xl w-[400px]'> 
              <h1 className='font-poppins py-10'>Smart Power Cut Notifier using Arduino Uno</h1>
              <h1 className=' py-10'>Developed a Smart Power Cut Notifier using Arduino Uno, addressing the need for efficient power outage detection and notification.
Designed a system where the Arduino board detects power cuts in specific houses while neighboring houses maintain power supply.
Implemented a messaging feature to instantly alert the operator with the specific address where the power outage occurs, enabling quick error identification and resolution.
</h1>
              <h1 className=' py-10'>Developed a web interface that displays real-time information regarding the availability of power supply in each house, providing a convenient solution for both operators and users.
Demonstrated problem-solving skills and technical expertise in hardware programming, utilizing Arduino Uno to accurately detect power cuts and transmit notifications.</h1>
              </div>
              </button>

              <button className='shadow-2xl shadow-slate-400 bg-slate-200 rounded-xl px-5 py-10 pb-20 hover:animate-pulse text-black text-left font-poppins  ' href="">
      <h1 className='text-black font-poppins pb-20 text-2xl'>HER-INSTINCTS</h1>
              <div className=' text-zinc-500 font-serif text-xl w-[400px]'> 
              <h1 className='font-poppins py-10'> Comprehensive website catering to women's care using HTML, Tailwind CSS, and Python.
</h1>
              <h1 className=' py-10'>Implemented HTML to structure the website's content, ensuring a clean and organized layout.
Utilized Tailwind CSS to create a visually appealing and responsive design, enhancing user experience across different devices.</h1>
              <h1 className=' py-10'>Leveraged Python to add dynamic functionality, such as personalized recommendations and content based on individual preferences.
Incorporated various features, including health tips, beauty routines, lifestyle advice, and empowerment resources, to address the unique needs of women.

 </h1>
              </div>
              </button>
              </div>
              
    </div>
    </div>


    </div>
  )
}

export default Projects